// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WorkItemCommentModel from '../../model/work-item-comment-model';
import WorkItemCommentDTO from '../dto/work-item-comment-dto';
import dtoSchema from '../schemas/work-item-comment-schema';

export default abstract class WorkItemCommentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WorkItemCommentDTO>) {
    super();
    if (data) {
      this.comment = data.comment ?? undefined;
      this.createdDate = data.createdDate;
    }
  }
  /**
  */
  comment?: string;
  /**
  * @type {date-time}
  */
  createdDate?: string;

  static toModel(dto: DeepPartial<WorkItemCommentDTO>): WorkItemCommentModel;
  static toModel(dto: DeepPartial<WorkItemCommentDTO> | undefined | null): WorkItemCommentModel | undefined;
  static toModel(dto: DeepPartial<WorkItemCommentDTO> | undefined | null): WorkItemCommentModel | undefined {
    return dto ? new WorkItemCommentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WorkItemCommentModel> | WorkItemCommentModel): WorkItemCommentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      comment: unwrapped.comment,
      createdDate: unwrapped.createdDate,
    } as WorkItemCommentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WorkItemCommentModel, can not map to WorkItemCommentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
